var _polygon;
import * as React from "react";
var SvgArrowTeaser = function SvgArrowTeaser(props) {
  return _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1.0120279,9.0029167 1.0120279,7.0070833 11.636424,7.0070833 9.2397402,4.6106658 11.63474,4.61 15.02974,8.0053329 11.63474,11.3998 9.2397402,11.4 11.636624,9.0029167"
  }));
};
export default SvgArrowTeaser;